var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_2732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.293848 4.70615C-0.0967767 4.31553 -0.0967767 3.68115 0.293848 3.29053C0.684473 2.8999 1.31885 2.8999 1.70947 3.29053L5.0001 6.58428L8.29385 3.29365C8.68447 2.90303 9.31885 2.90303 9.70947 3.29365C10.1001 3.68428 10.1001 4.31865 9.70947 4.70928L6.41572 7.9999L9.70635 11.2937C10.097 11.6843 10.097 12.3187 9.70635 12.7093C9.31572 13.0999 8.68135 13.0999 8.29072 12.7093L5.0001 9.41553L1.70635 12.7062C1.31572 13.0968 0.681348 13.0968 0.290723 12.7062C-0.0999019 12.3155 -0.0999019 11.6812 0.290723 11.2905L3.58447 7.9999L0.293848 4.70615Z",
    fill: "#F5F2F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_2732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 10 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.42e5b0cfb51e3bea94099be402173c22.svg";
export { ForwardRef as ReactComponent };